export enum OccupationalLevel {
    "Unknown Value" = -1,
    "Executive Director" = 1,
    "Non Executive Director" = 2,
    "Executive Management" = 3,
    "Other Executive Management" = 4,
    "Senior Management" = 5,
    "Middle Management" = 6,
    "Junior Management" = 7,
    "Semi skilled" = 8,
    "Unskilled" = 9,
    "Unspecified" = 10,
}